export const CAMPAIGN_TITLE_ACCENT =
  'bg-gradient-to-r from-[#2E90FA] via-[#22CCEE] to-brand bg-clip-text text-transparent';
